/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import {PropTypes} from 'preact-compat';

import styles from '../../../css/fullScreenMessage.css';

export const FullScreenMessage = ({messages = []}) => (
  <div className={styles.container}>
    <div className={styles.centerColumn}>
      {messages.map((message, idx) =>
        <p key={idx} className={styles.message} dangerouslySetInnerHTML={{__html: message}}/>
      )}
    </div>
  </div>
);

FullScreenMessage.propTypes = {messages: PropTypes.array};

export default FullScreenMessage;